import React from 'react'
import moment from 'moment'
import { Badge } from 'reactstrap'
import useTranslation from '../hooks/UseTranslation'

const DayIcon = (props) => {
  const { t } = useTranslation()
  const [day, setDay] = React.useState(props.day)

  const today = moment()
  const tomorrow = moment().add(1, 'day')

  React.useEffect(() => {
    setDay(props.day)
  }, [props.day])

  let soonText = null
  if (props.showSubtitle) {
    if (day.isSame(today, 'day')) {
      soonText = t('calendar_today')
    } else if (day.isSame(tomorrow, 'day')) {
      soonText = t('calendar_tomorrow')
    }
  }

  return (
    <div className='d-flex flex-column align-items-center'>
      <div className='date-tile mr-3 '>
        <div className='text-uppercase'>
          <span className='text-sm'>{day.local().format('MMM')}</span>
          <br />
          <strong className=''>{day.format('ddd DD')}</strong>
        </div>
      </div>
      {soonText && (
        <Badge className='mr-3 mt-2' color='info'>
          {soonText}
        </Badge>
      )}
    </div>
  )
}

export default DayIcon
